<pmt-action-modal [title]="'assignments.participants.contactParticipants' | transloco"
    [submitButtonText]="'modal.sendButton' | transloco" [submitButtonIconCode]="''" (submitted)="saveForm()"
    class="custom-modal-limiter" [isSaving]="isLoading">
    <div class="d-flex flex-column gap-2" [formGroup]="participantContactForm">
        <div>
            <label for="subject">{{'assignments.participants.mailSubject' | transloco}}</label>
            <div>
                <input id="subject" class="form-control" formControlName="subject" type="text">
                <p class="invalid-feedback">
                    {{'assignments.participants.subjectValidation' | transloco}}
                </p>
            </div>
        </div>

        <div>
            <label for="message">{{'assignments.participants.mailMessage' | transloco}}</label>
            <div>
                <quill-editor class="w-100 resizable-quill" [modules]="editorModule" id="message"
                    formControlName="message" [placeholder]="'shared.emailing.messagePlaceholder' | transloco">
                </quill-editor>
                <p class="invalid-feedback">
                    {{'assignments.participants.messageValidation' | transloco}}
                </p>
            </div>
        </div>
    </div>
</pmt-action-modal>